<template>  
    <section class="block block--textonly">
        <div class="container">
            <h2 v-if="block.title">{{ block.title }}</h2>
            <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
            <div v-if="block.content" v-html="block.content"></div>
        </div>
    </section>
</template>

<script>

export default { 
    name: 'textonly',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>